var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6,23.4c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.3c0.9-0.9,8.5-8.6,8.5-13.4 c0-2.5-1-4.8-2.7-6.6c-1.7-1.7-4.1-2.7-6.6-2.7c-2.5,0-4.8,1-6.6,2.7C3.7,5,2.7,7.3,2.7,9.8c0,4.8,7.6,12.5,8.5,13.4 C11.3,23.3,11.4,23.4,11.6,23.4z M7.1,4.9c1.3-1.3,3.1-2,4.9-2s3.6,0.7,4.9,2c1.3,1.3,2,3.1,2,4.9c0,2.9-4.5,8.2-7,10.9 c-2.5-2.7-7-8-7-10.9C5,7.9,5.8,6.2,7.1,4.9z M9.4,13.6c0.8,0.5,1.7,0.8,2.6,0.8c1.2,0,2.4-0.5,3.3-1.4c0.9-0.9,1.4-2.1,1.4-3.3 c0-0.9-0.3-1.8-0.8-2.6c-0.5-0.8-1.2-1.4-2.1-1.7C12.9,5.1,12,5,11.1,5.2S9.4,5.8,8.7,6.5C8.1,7.1,7.6,8,7.4,8.9 c-0.2,0.9-0.1,1.8,0.3,2.7C8.1,12.4,8.7,13.1,9.4,13.6z M10.7,7.9c0.4-0.3,0.8-0.4,1.3-0.4c0.6,0,1.2,0.2,1.6,0.7 c0.4,0.4,0.7,1,0.7,1.6c0,0.5-0.1,0.9-0.4,1.3s-0.6,0.7-1,0.9c-0.4,0.2-0.9,0.2-1.3,0.1c-0.4-0.1-0.9-0.3-1.2-0.6 c-0.3-0.3-0.5-0.7-0.6-1.2c-0.1-0.4,0-0.9,0.1-1.3C10,8.5,10.3,8.1,10.7,7.9z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d629a2eb799fff23d54a29735600bd33.svg";
export { ForwardRef as ReactComponent };